import React from "react";
import Header from "../components/Header";
import "../assets/css/Naviate.css";
import data from "../assets/config/NaviateMEP.json"
import Template from "../components/Template";

export default function NaviateMEPPage() {
  return (
    <>
      <Header className="header" name="MEP" />
      <div className="background-container"></div>
      <Template data={data} />
    </>
  );
}
